module.exports = __webpack_public_path__ + "img/Insurance.60a4a1c5.svg";